document.addEventListener('DOMContentLoaded', function() {
    const menuItems = document.querySelectorAll('.mobile__menu .has-child > a');
  
    menuItems.forEach(function(menuItem) {
      menuItem.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the default link behavior
  
        const parentMenuItem = this.parentNode;
        const submenu = parentMenuItem.querySelector('.wp-block-navigation__submenu-container');
  
        if (submenu.style.display === 'block') {
          submenu.style.display = 'none';
          this.classList.remove('active');
        } else {
          submenu.style.display = 'block';
          this.classList.add('active');
        }
      });
    });
  });
  


  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.wp-block-navigation-submenu__toggle').forEach(toggle => {
      toggle.addEventListener('click', () => {
        const li = toggle.parentElement;
  
        if (
          li.classList.contains('ddl-active') ||
          li.querySelectorAll('.ddl-active').length !== 0 ||
          li.querySelector('.wp-block-navigation-submenu').offsetHeight > 0
        ) {
          li.classList.remove('ddl-active');
          li.querySelectorAll('.ddl-active').forEach(active => {
            active.classList.remove('ddl-active');
          });
          li.querySelector('.wp-block-navigation-submenu').style.display = 'none';
        } else {
          li.classList.add('ddl-active');
          li.querySelector('.wp-block-navigation-submenu').style.display = 'block';
        }
      });
    });
  });
  